export default __webpack_public_path__ + "static/media/frontpage.2a79f7a0.txt";